import { Button, ButtonGroup, Content, Dialog, Divider, Flex, Footer, Header, Heading, Key, ProgressBar, Selection, TextField, View } from '@adobe/react-spectrum';
import { FPAData, FPADataTypes } from '../../../infra/protected/FPA/FPAData';
import { useContextNewDialog } from './ContextNewDialog.hooks';
import { FinderContextTree } from '../../../pages/protected/finder/components/FinderContextTree';
import styles from './ContextNewDialog.module.css';
import { FolderContextFields } from './FolderContextFields';
import { ProjectContextFields } from './ProjectContextFields';
import { ActivityContextFields } from './ActivityContextField';
import { useState } from 'react';

export interface IContextNewDialogProps {
    parentItem: FPAData | null;
    onClose: (reload_flag:boolean) => void;
    additionalMode: boolean;
    additionalData?: { fpaTypeCategory: string, fpaType: 'FOLDER'|'PROJECT'|'ACTIVITY' };
}

export function ContextNewDialog ({
    onClose,
    parentItem,
    additionalMode,
    additionalData
}: IContextNewDialogProps) {
    const [selectedKeys, setSelectedKeys] = useState<Selection>();
    const [expandedKeys, setExpandedKeys] = useState<Set<Key>>();

    const { 
        treeData, 
        onSelection, 
        loading, 
        currentStep,
        nextStep ,
        prevStep,
        selectedItem,
        settings,
        setFormData,
        contextTypeFormId,
        activityType
    } = useContextNewDialog({ parentItem, onClose, additionalMode, additionalData });

    const showFields = () => {
        if(selectedItem){
            switch (selectedItem.type) {
                case FPADataTypes.FOLDER:
                    return <FolderContextFields settings={settings} parentItem={parentItem} selectedItem={selectedItem} contextTypeFormId={contextTypeFormId} setFormData={setFormData} activityType={activityType} />;
                case FPADataTypes.PROJECT:
                    return <ProjectContextFields settings={settings} parentItem={parentItem} selectedItem={selectedItem} contextTypeFormId={contextTypeFormId} setFormData={setFormData} activityType={activityType} />;
                case FPADataTypes.ACTIVITY:
                    return <ActivityContextFields settings={settings} parentItem={parentItem} selectedItem={selectedItem} contextTypeFormId={contextTypeFormId} setFormData={setFormData} activityType={activityType} />;
                default:
                    return (<>Unknown item type selected</>)
            }
        }
    }
    return (
        <Dialog>
            <Heading>
                Add {selectedItem ? selectedItem.title : 'New Context'}
            </Heading>
            <Header>
                {currentStep === 1 ? 'Step 1' : 'Step 2'}
            </Header>
            <Divider />
            <Content>
                {currentStep === 1 && (
                    <Flex direction="column">
                        <View>
                            <TextField label="Choose context" autoFocus width={'100%'} />
                        </View>
                        <View>
                            <FinderContextTree 
                                items={treeData} 
                                onSelection={onSelection} 
                                expandedKeys={expandedKeys}
                                setExpandedKeys={setExpandedKeys}
                                selectedKeys={selectedKeys}
                                setSelectedKeys={setSelectedKeys}
                                />
                        </View>
                    </Flex>
                )}
                {currentStep === 2 && (
                    <Flex direction="column">
                        <View>
                            Fill in the details
                        </View>
                        {showFields()}
                    </Flex>
                )}
            </Content>
            <Footer>
                <Flex direction={'column'}>
                    {currentStep == 2 && selectedItem && (
                        <Button variant='secondary' onPress={() => prevStep()}>Back</Button>
                    )}
                    <View>
                        {loading && (<ProgressBar label="Loading..." isIndeterminate />)}
                    </View>
                </Flex>
            </Footer>
            <ButtonGroup>
                <Button variant="secondary" onPress={() => onClose(false)}>Cancel</Button>
                <Button variant="accent" onPress={nextStep}>{currentStep == 1 ? "Next" : "Save" }</Button>
            </ButtonGroup>
        </Dialog>
    );
}
